import React from 'react';
import { useTranslation } from 'react-i18next';
import { region } from '../../utils/region';

// AI Marketing's subtitle: "<country> business directory (<city> · <city> …)". The cities are the workspace
// setting (useMarketCities), the country is the region's, named in the UI language by the browser
// (Intl.DisplayNames) — no place name is written in the client.
export default function MarketSubtitle({ cities }: { cities: string[] }) {
  const { t, i18n } = useTranslation();
  const code = region().country;
  let country = '';
  try { country = code ? new Intl.DisplayNames([i18n.language || 'en'], { type: 'region' }).of(code) || '' : ''; } catch { country = ''; }
  const list = cities.length ? cities.join(' · ') : '—';
  return <>{country ? t('fc_am_subtitle', { country, cities: list }) : t('fc_am_subtitle_nocountry', { cities: list })}</>;
}
